import { Box, TextField, Typography } from "@mui/material";
import { ArrowForward, Close, Done } from "@mui/icons-material";

import Theme from "../../../../../utils/Theme";
import { SalesAidsStyles } from "./SalesAidsStyles";
import { generateRandomId } from "../../../../../utils/Utils";
import AddIconUtils from "../../../../../utils/AddIconUtils";

const TextArtifacts = ({
  artifacts,
  setArtifacts,
  handleRemove,
  handleArrowClick,
}) => {
  const handleTextChange = (index, field, value) => {
    console.log("handleTextChange", index, value);
    setArtifacts((prev) => ({
      ...prev,
      text: prev?.text?.map((item, i) =>
        i === index
          ? {
              ...item,
              [field]: value,
              isEdit: true,
            }
          : item
      ),
    }));
  };

  const handleAddNew = () => {
    const newTextArtifact = {
      text: "",
      es_text: "",
      position: null,
      artifactId: generateRandomId(6),
      isEdit: false,
    };
    setArtifacts((prev) => ({
      ...prev,
      text: [...prev?.text, newTextArtifact],
    }));
  };
  return (
    <Box sx={SalesAidsStyles.outerBox}>
      {artifacts?.map((item, index) => (
        <Box
          key={item?.id}
          sx={{
            ...SalesAidsStyles.innerBox,
            bgcolor: item?.isEdit ? "#FFF7F7" : null,
          }}
        >
          {/* Cross Icon (aligned with TextField center) */}
          <Close
            sx={SalesAidsStyles.closeIcon}
            onClick={() => handleRemove(item, "text")}
          />

          {/* English Column */}
          <Box sx={SalesAidsStyles.subheadingBox}>
            <Typography sx={SalesAidsStyles.wordStyle}>English</Typography>
            <TextField
              fullWidth
              variant="outlined"
              label={"Message to be displayed"}
              onChange={(e) => handleTextChange(index, "text", e.target.value)}
              value={item?.text}
              multiline
            />
          </Box>

          {/* Spanish Column */}
          <Box sx={SalesAidsStyles.subheadingBox}>
            <Typography sx={SalesAidsStyles.wordStyle}>Spanish</Typography>
            <TextField
              fullWidth
              variant="outlined"
              label={"Mensaje a mostrar"}
              onChange={(e) =>
                handleTextChange(index, "es_text", e.target.value)
              }
              value={item?.es_text}
              multiline
            />
          </Box>

          {item?.isEdit ? (
            <Done
              sx={{
                ...SalesAidsStyles.doneIcon,
                color:
                  item?.text || item?.es_text
                    ? Theme.palette.primary.main
                    : Theme.palette.action.disabled,
                cursor: item?.text || item?.es_text ? "pointer" : "not-allowed",
              }}
              onClick={() => handleArrowClick(item, "text")}
            />
          ) : (
            <ArrowForward
              sx={{
                ...SalesAidsStyles.arrowForward,
                color: item?.text|| item?.es_text
                  ? Theme.palette.primary.main
                  : Theme.palette.action.disabled,
                cursor: item?.text|| item?.es_text ? "pointer" : "not-allowed",
              }}
              onClick={() => handleArrowClick(item, "text")}
            />
          )}
        </Box>
      ))}

      <AddIconUtils
        artifacts={artifacts}
        handleAddNew={handleAddNew}
        total={10}
      />
    </Box>
  );
};

export default TextArtifacts;

// <Box
//   key={item?.id}
//   sx={{
//     display: "flex",
//     flexDirection: "row",
//     gap: 2,
//     p: "15px 6px 6px 6px",
//     borderRadius: 2,
//     bgcolor: item?.isEdit ? "#FFF7F7" : null,
//     alignItems: "flex-start",
//   }}
// >
//   <Box
//     sx={{
//       display: "flex",
//       flexDirection: "row",
//       gap: 2,
//       width: edit ? "16%" : "20%",
//       alignItems: "center",
//     }}
//   >
//     <Close
//       sx={{ ...SalesAidsStyles.closeIcon }}
//       onClick={() => handleRemove(item, "text")}
//     />

//     <Autocomplete
//       sx={{ width: "100%" }}
//       options={options}
//       value={"English"}
//       disabled={true}
//       renderInput={(params) => {
//         return <TextField {...params} />;
//       }}
//     />
//   </Box>
//   <Box
//     sx={{
//       display: "flex",
//       flexDirection: "row",
//       justifyContent: "space-between",
//       gap: 2,
//       alignItems: "center",
//       width: edit ? "84%" : "80%",
//     }}
//   >
//     <TextField
//       fullWidth
//       variant="outlined"
//       label={"Message to be displayed"}
//       onChange={(e) => handleTextChange(index, e.target.value)}
//       value={artifacts[index]?.text}
//       multiline
//     />
//     {item?.isEdit ? (
//       <Done
//         sx={{
//           fontSize: 20,
//           color: Theme.palette.primary.main,
//           color: item?.text
//             ? Theme.palette.primary.main
//             : Theme.palette.action.disabled,
//           cursor: item?.text ? "pointer" : "not-allowed",
//         }}
//         onClick={() => handleArrowClick(item, "text")}
//       />
//     ) : (
//       <ArrowForward
//         sx={{
//           ...SalesAidsStyles.arrowForward,
//           color: item?.text
//             ? Theme.palette.primary.main
//             : Theme.palette.action.disabled,
//           cursor: item?.text ? "pointer" : "not-allowed",
//         }}
//         onClick={() => handleArrowClick(item, "text")}
//       />
//     )}
//   </Box>
// </Box>
